import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import {
	Dropdown,
	Spinner,
	Icon,
	Alert,
} from './';

// Import the CSS
import '../../scss/containers/feeds/_link-pane.scss';

export default class CorporationFeedLink extends Component {

	handleClickUpdate (e) {
		e.preventDefault();

		this.props.onUpdate();
	}

	render() {
		return (
			<div className="corporation-linking-pane-list-item">
				<div className="corporation-linking-pane-row">
					<div className="corporation-details">
						<div>{ this.props.corporation.name }</div>
						<div>{ this.props.corporation.number }</div>
					</div>

					<If condition={ this.props.showUpdateButton }>
						<Choose>
							<When condition={ this.props.status === 'updated' }>
								<div className="corporation-action-success">
									<Icon type="check-circle" />
									Updated
								</div>
							</When>
							<When condition={ this.props.status === 'updating' }>
								<Spinner style="inline" />
								<a href="#" className="disabled corporation-action-btn">
									<span>Updating...</span>
								</a>
							</When>
							<Otherwise>
								<a href="#" className="corporation-action-btn" onClick={ e => this.handleClickUpdate(e) }>
									Update
								</a>
							</Otherwise>
						</Choose>
					</If>
				</div>

				<If condition={ this.props.error }>
					<Alert type="tooltip" dismissTimer={5000} style="error">
						{ this.props.error.body.message }
					</Alert>
				</If>

				<If condition={ this.props.showDropdown }>
					<div className="corporation-linking-pane-row">
						<Dropdown
							wrap
							selected={ this.props.selected }
							name="corporation-update-dropdown"
							onChange={ option => this.props.onChange(option) }
							emptyLabel={ <span className="placeholder"> Update with a corporation from the feed </span> }
							options={ this.props.options } />
					</div>
				</If>
			</div>
		);
	}

}

CorporationFeedLink.propTypes = {
	corporation: PropTypes.object.isRequired,
	onUpdate: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	showUpdateButton: PropTypes.bool,
	showDropdown: PropTypes.bool,
	selected: PropTypes.object,
	options: PropTypes.array,
	error: PropTypes.object,
	status: PropTypes.oneOf([
		'',
		'updated',
		'updating',
	]),
};



// WEBPACK FOOTER //
// ./src/assets/js/components/CorporationFeedLink.js